<template>
  <div class="hero-preview" aria-hidden="true">
    <div class="hero-preview__card hero-preview__card--left">
      <span class="hero-preview__card-head">
        <span class="hero-preview__card-tag">Скрипти</span>
        <span class="hero-preview__card-format">PDF</span>
      </span>
      <span class="hero-preview__card-title">Що відповісти на «дорого»</span>
      <span class="hero-preview__card-body">
        <span v-for="line in scriptLines" :key="line">{{ line }}</span>
      </span>
    </div>
    <div class="hero-preview__card hero-preview__card--right">
      <span class="hero-preview__card-head">
        <span class="hero-preview__card-tag">Інструкція</span>
        <span class="hero-preview__card-format">PDF</span>
      </span>
      <span class="hero-preview__card-title">Сайт-візитка агента за 30 хвилин</span>
      <span class="hero-preview__card-body">
        <span v-for="line in siteLines" :key="line">{{ line }}</span>
      </span>
    </div>
    <div class="hero-preview__card hero-preview__card--main">
      <span class="hero-preview__badge">Безкоштовно на email</span>
      <span class="hero-preview__card-head">
        <span class="hero-preview__card-tag hero-preview__card-tag--accent">Гайд · 6 уроків</span>
        <span class="hero-preview__card-format">PDF</span>
      </span>
      <span class="hero-preview__card-title hero-preview__card-title--large">Як продавати поліси, щоб клієнти поверталися</span>
      <span class="hero-preview__card-body hero-preview__card-body--checklist">
        <span v-for="item in checklist" :key="item.text" class="hero-preview__card-check">
          <span class="hero-preview__card-box" :class="{ 'hero-preview__card-box--done': item.done }">
            <CheckLineIcon v-if="item.done" :size="12" color="#FFFFFF" />
          </span>
          {{ item.text }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { CheckLineIcon } from '@/shared/ui/icons';

export default {
  components: { CheckLineIcon },
  data() {
    return {
      scriptLines: [
        '«Розумію. Давайте порівняємо, що входить у поліс за цю ціну…»',
        '«Дешевший варіант є — ось у чому різниця для вас…»',
        '«Якщо станеться ДТП, різниця в ціні окупиться…»',
      ],
      siteLines: [
        '1. Увійдіть у кабінет і відкрийте розділ сайту',
        '2. Оберіть продукти й додайте свої контакти',
        '3. Скопіюйте посилання і поділіться з клієнтами',
      ],
      checklist: [
        { text: 'Спершу питання, потім продукт', done: true },
        { text: 'Продукт за 30 секунд', done: true },
        { text: 'Що відповісти на «дорого»', done: false },
        { text: 'Написати клієнту в правильний момент', done: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.hero-preview {
  position: relative;
  flex: 1 1 460px;
  max-width: 520px;
  height: 470px;
  margin: 0 auto;

  @media (max-width: 800px) {
    display: none;
  }

  &__card {
    position: absolute;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 22px;
    width: 230px;
    height: 290px;
    border-radius: 24px;
    background: #FFFFFF;
    box-shadow: 0 16px 48px rgba(55, 58, 61, 0.10);

    &--left {
      top: 36px;
      left: 0;
      transform: rotate(-8deg);
    }

    &--right {
      top: 0;
      right: 0;
      transform: rotate(7deg);
    }

    &--main {
      top: 150px;
      left: 50%;
      width: 310px;
      height: auto;
      gap: 14px;
      padding: 26px;
      border-radius: 28px;
      box-shadow: 0 24px 64px rgba(55, 58, 61, 0.18);
      transform: translateX(-50%) rotate(-1.5deg);
      z-index: 1;
    }
  }

  &__badge {
    position: absolute;
    top: -22px;
    right: -26px;
    padding: 10px 16px;
    border-radius: 14px;
    background: linear-gradient(100deg, #F5AB72, #EB8C42);
    box-shadow: 0 10px 24px rgba(235, 140, 66, 0.35);
    color: #373A3D;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    white-space: nowrap;
    transform: rotate(10deg);
  }

  &__card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__card-tag {
    padding: 5px 12px;
    border-radius: 999px;
    background: #EBF2FF;
    color: #4555CC;
    font-size: 13px;
    font-weight: 600;

    &--accent {
      background: #4555CC;
      color: #FFFFFF;
    }
  }

  &__card-format {
    font-size: 12px;
    font-weight: 700;
    color: #81878F;
  }

  &__card-title {
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #373A3D;

    &--large {
      font-size: 22px;
      line-height: 28px;
    }
  }

  &__card-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 13px;
    line-height: 18px;
    color: #494E53;
    filter: blur(3px);
    user-select: none;

    &--checklist {
      gap: 14px;
      font-size: 14px;
      line-height: 19px;
      filter: blur(3.5px);
    }
  }

  &__card-check {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__card-box {
    flex: none;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    box-shadow: inset 0 0 0 2px #6171E4;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &--done {
      background: #6171E4;
      box-shadow: none;
    }
  }
}
</style>
